
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Minus, ChevronUp, ChevronDown, Flag } from "lucide-react";

interface InningControlProps {
  count: number;
  isTopInning: boolean;
  onCountChange: (count: number) => void;
  onInningHalfChange: (isTop: boolean) => void;
}

export function InningControl({ 
  count, 
  isTopInning, 
  onCountChange, 
  onInningHalfChange 
}: InningControlProps) {
  // Set game to final inning
  const handleFinalInning = () => {
    onCountChange(99); // Using 99 as a special value to indicate "Final"
  };

  return (
    <div className="flex gap-4">
      <div className="space-y-3 flex-1">
        <h4 className="text-lg sm:text-xl font-semibold text-white">Inning</h4>
        <div className="flex items-center gap-2">
          <Button 
            onClick={() => onCountChange(Math.max(1, count - 1))} 
            variant="outline"
            size="icon"
            className="flex-1 border-white/20 h-10"
          >
            <Minus className="h-4 w-4" />
          </Button>
          <div className="text-2xl sm:text-3xl font-bold text-white w-12 text-center">
            {count === 99 ? "F" : count.toString().padStart(2, '0')}
          </div>
          <Button 
            onClick={() => onCountChange(Math.min(14, count + 1))} 
            variant="outline"
            size="icon"
            className="flex-1 border-white/20 h-10"
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-lg sm:text-xl font-semibold text-white opacity-0">Half</h4>
        <div className="flex flex-col gap-1">
          <Button 
            onClick={() => onInningHalfChange(true)}
            variant={isTopInning ? "default" : "outline"}
            size="icon"
            className={`border-white/20 h-10 ${!isTopInning && 'hover:bg-[#9b87f5]/10'}`}
          >
            <ChevronUp className="h-4 w-4" />
          </Button>
          <Button 
            onClick={() => onInningHalfChange(false)}
            variant={!isTopInning ? "default" : "outline"}
            size="icon"
            className={`border-white/20 h-10 ${isTopInning && 'hover:bg-[#9b87f5]/10'}`}
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </div>
      </div>
      
      {/* Final Inning Button */}
      <div className="space-y-3">
        <h4 className="text-lg sm:text-xl font-semibold text-white">Final</h4>
        <Button 
          onClick={handleFinalInning}
          variant="outline"
          className="border-white/20 h-10 px-3 bg-black/30 hover:bg-[#9b87f5]/20"
          title="Set to final inning"
        >
          <Flag className="h-4 w-4 mr-1" />
          F
        </Button>
      </div>
    </div>
  );
}
